import type { Product } from "../Product.js";

export function isProductConsideredNew(product: Pick<Product, "markedAsNewAt">): boolean {
	return Date.parse(product.markedAsNewAt ?? "") <= Date.now();
}
